module.exports = __webpack_public_path__ + "static/img/pexels-darius-krause-2228183@2x.c12ffa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productIntroduction/pexels-darius-krause-2228183@2x.png
// module id = a90l
// module chunks = 0